export default __webpack_public_path__ + "assets/images/d2edff6daeef62e2ad5140ca7bc3cc2e.svg";